import React, { useState } from 'react';
import './Pages.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <main className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>Get in Touch</h1>
          <p>Have a question or project in mind? We'd love to hear from you.</p>
        </div>
      </section>

      <section className="container page-section">
        <div className="contact-layout">
          <div className="contact-form">
            <h2>Send us a Message</h2>
            {submitted && (
              <div className="success-message">
                Thank you for your message! We'll get back to you soon.
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-primary">Send Message</button>
            </form>
          </div>

          <div className="contact-info">
            <h2>Contact Information</h2>
            <div className="info-card">
              <h3>Email</h3>
              <p><a href="mailto:info@yourbrand.com">info@yourbrand.com</a></p>
              <small>We'll respond within 24 hours</small>
            </div>
            <div className="info-card">
              <h3>Phone</h3>
              <p><a href="tel:+1234567890">+1 (234) 567-890</a></p>
              <small>Monday - Friday, 9 AM - 6 PM EST</small>
            </div>
            <div className="info-card">
              <h3>Office</h3>
              <p>123 Business Street<br/>City, State 12345</p>
            </div>
            <div className="info-card">
              <h3>Follow Us</h3>
              <p>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a> | 
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a> | 
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
